<template>
  <b-modal
    ref="modalServicosOmie"
    :title="'Selecione o serviço Omie'"
    size="xl"
    no-close-on-backdrop
    :dialog-class="'alteracao-tamanho'"
    :modal-class="'center-modal'"
    @show="buscarServicosOmies()"
  >
    <vue-good-table
      :columns="columns"
      :rows="rows"
      theme="view"
      max-height="450px"
      :fixed-header="true"
      :row-style-class="'style-dados'"
      style-class="vgt-table bordered"
      :sort-options="{
        enabled: true,
        initialSortBy: {field: 'descricaoResumida', type: 'asc'}
      }"
      :search-options="{
        enabled: true,
        searchFn: searchServicoFn,
        placeholder: 'Busca por palavra chave'
      }"
    >
      <div slot="emptystate">
        <p style="text-align:center; margin:0">
          Nenhum serviço Omie encontrado.
        </p>
      </div>
      <template
        slot="table-row"
        slot-scope="props"
      >
        <b-checkbox
          v-if="props.column.field === 'check'"
          v-model="props.row.check"
          :checked="props.row.check"
          @change="checkboxClicked(props.row)"
        />
        <span v-if="props.column.field === 'codigo'">{{ props.row.cabecalho.cCodigo }}</span>
        <span v-if="props.column.field === 'descricaoResumida'">{{ props.row.cabecalho.cDescricao }}</span>
        <span v-if="props.column.field === 'descricaoCompleta'">{{ props.row.descricao.cDescrCompleta }}</span>
      </template>
    </vue-good-table>
    <template #modal-footer>
      <b-btn
        variant="none"
        size="sm"
        class="btn-primary"
        style="margin-left: 0;"
        @click="$refs.modalServicosOmie.hide()"
      >Confirma</b-btn>
    </template>
  </b-modal>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.style-dados {
  font-size: 13px;
}

.alteracao-tamanho {
  width: 1400px !important;
}

.center-modal {
  display: flex !important;
  justify-content: center !important;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import api from '@/app-modulo/comuns/servico/shared/services/api'

export default {
  name: 'ServicosOmie',
  components: {
    VueGoodTable,
  },
  props: {
    idOmie: {
      type: Number,
      default: null,
    },
    simplesNacional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns: [
        {
          label: '',
          field: 'check',
          thClass: 'style-dados',
          sortable: false,
          width: '35px',
        },
        {
          label: 'Código',
          field: 'codigo',
          thClass: 'style-dados',
          sortable: true,
          sortFn: this.sortFn,
        },
        {
          label: 'Descrição resumida',
          field: 'descricaoResumida',
          thClass: 'style-dados',
          sortable: true,
          sortFn: this.sortFn,
          width: '450px',
        },
        {
          label: 'Descrição',
          field: 'descricaoCompleta',
          thClass: 'style-dados',
          sortable: true,
          sortFn: this.sortFn,
        },
      ],
      rows: [],
      selecionado: null,
    }
  },
  methods: {
    show() {
      this.$refs.modalServicosOmie.show()
    },
    buscarServicosOmies() {
      api.listaServicosOmie(this.simplesNacional)
        .then(payload => {
          const linhas = payload.data
          const row = linhas.find(fin => fin.intListar.nCodServ === this.idOmie)
          if (row) {
            row.check = true
            this.selecionado = row
            const index = linhas.findIndex(fin => fin.intListar.nCodServ === this.idOmie)
            this.rows.splice(index, 1)
            this.rows.splice(index, 0, row)
          }

          this.rows = linhas
        })
    },
    checkboxClicked(prop) {
      if (this.selecionado !== null && this.selecionado.intListar.nCodServ !== prop.intListar.nCodServ) {
        const row = this.rows.find(fin => fin.intListar.nCodServ === this.selecionado.intListar.nCodServ)
        if (row) {
          row.check = false
          const index = this.rows.findIndex(fin => fin.intListar.nCodServ === this.selecionado.intListar.nCodServ)
          this.rows.splice(index, 1)
          this.rows.splice(index, 0, row)
        }
      }

      if (prop.check) {
        const rowAtual = this.rows.find(fin => fin.intListar.nCodServ === prop.intListar.nCodServ)
        if (rowAtual) {
          rowAtual.check = true
          const index = this.rows.findIndex(fin => fin.intListar.nCodServ === prop.intListar.nCodServ)
          this.rows.splice(index, 1)
          this.rows.splice(index, 0, rowAtual)
        }
      }
      this.selecionado = prop
      this.$emit('selecionado', prop)
    },
    sortFn(x, y, col, rowX, rowY) {
      if (col.field === 'codigo') {
        // eslint-disable-next-line no-nested-ternary
        return (rowX.cabecalho.cCodigo < rowY.cabecalho.cCodigo ? -1 : (rowX.cabecalho.cCodigo > rowY.cabecalho.cCodigo ? 1 : 0))
      }
      if (col.field === 'descricaoResumida') {
        // eslint-disable-next-line no-nested-ternary
        return (rowX.cabecalho.cDescricao < rowY.cabecalho.cDescricao ? -1 : (rowX.cabecalho.cDescricao > rowY.cabecalho.cDescricao ? 1 : 0))
      }
      // eslint-disable-next-line no-nested-ternary
      return (rowX.descricao.cDescrCompleta < rowY.descricao.cDescrCompleta ? -1 : (rowX.descricao.cDescrCompleta > rowY.descricao.cDescrCompleta ? 1 : 0))
    },
    searchServicoFn(row, col, cellValue, searchTerm) {
      if (col.field === 'codigo') {
        return row.cabecalho.cCodigo.toLowerCase().includes(searchTerm.toLowerCase())
      }

      if (col.field === 'descricaoResumida') {
        return row.cabecalho.cDescricao.toLowerCase().includes(searchTerm.toLowerCase())
      }

      return row.descricao.cDescrCompleta.toLowerCase().includes(searchTerm.toLowerCase())
    },
  },
}
</script>
